import React from "react";
import { PersonIcon } from "./Icons";
import cn from "../utils/cn";

function Input(
  props: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > & {
    icon?: React.ReactNode;
  }
) {
  return (
    <div className="bg-input-bg rounded-[4px] border-text-beige placeholder:text-text-beige border-2 p-6 flex gap-[10px] items-center">
      {props.icon && props.icon}
      <input
        {...props}
        className={cn(
          "bg-transparent text-[32px] flex-1 text-text-beige ",
          props.className
        )}
      />
    </div>
  );
}

export default Input;
